var ApexAssociatedProductItem = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new EventDelegator(this);
    this.productHandle = this.dataset.productHandle;
    this.salePrice = this.dataset.salePrice;
    this.tag = this.dataset.tag;
    this.viewMore = this.dataset.viewMore;
    this.viewLess = this.dataset.viewLess;
    this.buttonAdd = this.dataset.buttonAdd;
    this.addEventListener("click", this.showProductDialog.bind(this));
  }
  connectedCallback() {
    this._delegate.on("change", '.apex-associal-item__options [type="radio"]', this._onSwatchChanged.bind(this));
    this._delegate.on("pointerover", '.apex-associal-item__options [type="radio"] + label', this._onSwatchHovered.bind(this), true);
  }
  disconnectedCallback() {
    this._delegate.off();
    this.removeEventListener("click", this.showProductDialog.bind(this));
  }

  /** 展示商品详情弹窗 */
  showProductDialog() {
    new ApexProductDialog({
      handle: this.productHandle,
      salePrice: this.salePrice,
      tag: this.tag,
      viewMore: this.viewMore,
      viewLess: this.viewLess,
      buttonAdd: this.buttonAdd,
    });
  }
  async _onSwatchHovered(event, target) {
    const control = target.control;
    const primaryMediaElement = this.querySelector(".apex-associal-item__image img");
    if (control.hasAttribute("data-variant-media")) {
      this._createImageElement(JSON.parse(control.getAttribute("data-variant-media")), primaryMediaElement.className, primaryMediaElement.sizes);
    }
  }
  async _onSwatchChanged(event, target) {
    if (target.hasAttribute("data-variant-id")) {
      // this.querySelectorAll(`a[href^="${Shopify.routes.root}products/${this.getAttribute("handle")}"`).forEach((link) => {
      //   const url = new URL(link.href);
      //   url.searchParams.set("variant", target.getAttribute("data-variant-id"));
      //   link.href = `${url.pathname}${url.search}${url.hash}`;
      // });
      const id = target.getAttribute("data-variant-id");
      this.querySelector('.apex-associal-item__add-form [name="id"]').setAttribute("value", id);
      const pEl = this.querySelector(`i[data-v="${id}"]`);
      if (pEl) {
        const priceEl = this.querySelector(".apex-associal-item__price-list .price .ht-money");
        const delPriceEl = this.querySelector(".apex-associal-item__price-list .del-price .ht-money");
        const swatchEl = this.querySelector(".apex-associal-item__swatch");
        const _p = pEl.dataset.p,
          _dp = pEl.dataset.dp;
        priceEl && _p && (priceEl.textContent = Apex.currencyFormatter().formatPrice(_p));
        delPriceEl && _dp && (delPriceEl.textContent = Apex.currencyFormatter().formatPrice(_dp));
        if (swatchEl && pEl.dataset.title) {
          swatchEl.textContent = pEl.dataset.title;
        }
      }
    }
    if (!target.hasAttribute("data-variant-media")) {
      return;
    }
    // 修改图片
    const newMedia = JSON.parse(target.getAttribute("data-variant-media")),
      primaryMediaElement = this.querySelector(".apex-associal-item__image img"),
      newPrimaryMediaElement = this._createImageElement(newMedia, primaryMediaElement.className, primaryMediaElement.sizes);
    if (primaryMediaElement.src !== newPrimaryMediaElement.src) {
      await primaryMediaElement.animate({ opacity: [1, 0] }, { duration: 150, easing: "ease-in", fill: "forwards" }).finished;
      await new Promise((resolve) => (newPrimaryMediaElement.complete ? resolve() : (newPrimaryMediaElement.onload = () => resolve())));
      primaryMediaElement.replaceWith(newPrimaryMediaElement);
      newPrimaryMediaElement.animate({ opacity: [0, 1] }, { duration: 150, easing: "ease-in" });
    }
  }
  _createImageElement(media, classes, sizes) {
    return Apex.createMediaImg(media, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800], { class: classes, sizes });
  }
};
if (!window.customElements.get("apex-associated-product-item")) {
  window.customElements.define("apex-associated-product-item", ApexAssociatedProductItem);
}
